import React from 'react';

import { CookieConsent } from './cookie-consent';
import { CookieConsentModal } from './cookie-consent-modal';
import { useConfigContext } from '../../contexts';

type CookieConsentMainProps = {
    hasNavbarOnMobile: boolean;
};

export const CookieConsentMain: ({ hasNavbarOnMobile }: CookieConsentMainProps) => JSX.Element = ({
    hasNavbarOnMobile,
}: CookieConsentMainProps) => {
    const { features = [] } = useConfigContext();
    const shouldUseModal = features.some((item) => item.name === 'cookie-consent-required');

    return shouldUseModal ? <CookieConsentModal /> : <CookieConsent hasNavbarOnMobile={hasNavbarOnMobile} />;
};
